import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
import * as XLSX from 'xlsx';
import { differenceInCalendarDays, setHours } from 'date-fns';

@Component({
  selector: 'app-ticket-group-wise-summary',
  templateUrl: './ticket-group-wise-summary.component.html',
  styleUrls: ['./ticket-group-wise-summary.component.css']
})

export class TicketGroupWiseSummaryComponent implements OnInit {
  formTitle = "Ticket Group Wise Summary";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  fileName = 'DeptWise.xlsx';
  dataList = [];
  dataListForExport = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "ID";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
  columns: string[][] = [["TICKET_GROUP_VALUE", "Ticket Group"], ["TOTAL", "Total Ticket(s)"], ["CREATED", "Pending"], ["ASSIGNED", "Assigned"], ["ANSWERED", "Answered"], ["RE_OPEN", "Re-Opened"], ["CLOSED", "Closed"], ["BANNED", "Banned"], ["ON_HOLD", "On Hold"]];
  STATUS = "AL";
  TICKET_GROUP = [];
  SUPPORT_USER = 'AL';
  isSpinning = false;
  filterClass: string = "filter-visible";
  applicationId = Number(this.cookie.get('applicationId'));
  departmentId = Number(this.cookie.get('departmentId'));
  selectedDate: Date[] = [];
  dateFormat = 'dd/MM/yyyy';
  date: Date[] = [];
  data1 = [];
  index = 0;
  ticketQuestion = {};
  value1: string = "";
  value2: string = "";
  ticketGroups = [];
  supportusers = [];
  userId = Number(this.cookie.get('userId'));
  roleId = Number(this.cookie.get('roleId'));
  orgId = Number(this.cookie.get('orgId'));
  deptId = Number(this.cookie.get('deptId'));
  branchId = Number(this.cookie.get('branchId'));
  designationId = Number(this.cookie.get('designationId'));
  date1 = new Date();
  date2 = new Date();
  today = new Date();
  orgName: string = this.api.ORGANIZATION_NAME;

  constructor(private api: ApiService, private datePipe: DatePipe, private cookie: CookieService, private _exportService: ExportService, private message: NzNotificationService) { }

  disabledToDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.date1 == null ? this.today : this.date1) < 0;

  onFromDateChange(fromDate) {
    if (fromDate == null)
      this.date2 = new Date();

    else
      this.date2 = new Date(fromDate);
  }

  setDateForDeptWiseFilter() {
    this.date = [];
    let currentDate = new Date();
    let previous15thDayDate = currentDate.setDate(currentDate.getDate() + (-30));
    this.date1 = new Date(previous15thDayDate);
    this.date2 = new Date();
  }
supportUserIds
SUPPORT_USERS: any[] = [];   
supportUsers
  ngOnInit() {
    this.setDateForDeptWiseFilter();

    this.api.getAllTicketGroups(0, 0, 'VALUE', 'ASC', " AND ORG_ID= " + this.cookie.get('orgId')).subscribe(data => {
      if (data['code'] == 200) {
        this.ticketGroups = data['data'];
      }

    }, err => {
      console.log(err);
    });
this.getSupportUsers();

    if (this.roleId == 6)
  this.getDepartmentToShowReport();
    
    

    if (this.roleId == 4)
      this.getDepartmentSupportAgentWise();

    if ((this.roleId != 4) )
      this.search(true);

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";
  }

  getSupportUsers() {
    this.supportUsers = [];
     var reporthead= ""
if(this.roleId == 6 ){
  reporthead =" AND REPORTING_HEAD_ID = " + this.userId + " "
}  
    this.api.getAllemployeeMaster(0, 0, 'NAME', 'asc', ' AND ORG_ID=' + this.cookie.get('orgId') + reporthead + ' AND ID!=1').subscribe(data => {
      if (data['code'] == 200) {
        this.supportUsers = data['data'];
                        this.supportUserIds = data['data'].map((emp: any) => emp.ID);

    // ✅ Auto-select for role 6
    if (this.roleId == 6) {
      this.SUPPORT_USERS = this.supportUserIds;
       
      }
      }

    }, err => {
      console.log(err);
    });
  }
  supportAgentWiseDeptArray = [];

  getDepartmentSupportAgentWise() {
    this.supportAgentWiseDeptArray = [];

    this.api.gettickdeskSupportUserMapping(0, 0, 'ID', "ASC", ' AND EMPLOYEE_ID=' + this.userId).subscribe(data => {
      if (data['code'] == 200) {
        var supportAgentWiseDept = data['data'];

        for (var i = 0; i < supportAgentWiseDept.length; i++) {
          this.supportAgentWiseDeptArray.push(supportAgentWiseDept[i]['DEPARTMENT_ID']);
        }

        if (this.roleId == 4) {
          this.search(true);
        }
      }
    });
  }

 
    deptWiseReport = [];
DEPARTMENT_ID:any[] = [];  
departments
departmentsidd
getDepartmentToShowReport() {
    this.deptWiseReport = [];
  var departmentFilter = "";
   if(this.roleId == 6){
  this.api.gettickdeskDepartmentAdminMapping1(0, 0, 'ID', "ASC", ' AND EMPLOYEE_ID=' + this.userId).subscribe(data => {
      if (data['code'] == 200) {
        this.departments = data['data'];

    // ✅ Extract IDs separately
    this.departmentsidd = data['data'].map((emp: any) => emp.DEPARTMENT_ID);

    // ✅ Auto-select for role 6
      this.DEPARTMENT_ID = this.departmentsidd;
   
   

if (this.roleId == 6) {
  setTimeout(() => {
    this.search(true);
  }, 300);  // 300–500ms safe
}
         
        
      }
      
       
    });  
   }
    // this.api.gettickdeskDepartmentAdminMapping(0, 0, 'ID', "ASC", ' AND EMPLOYEE_ID=' + this.userId).subscribe(data => {
    //   if (data['code'] == 200) {
    //     var departments = data['data'];
    //     console.log(departments);

    //     for (var i = 0; i < departments.length; i++) {
    //       this.deptWiseReport.push(departments[i]['DEPARTMENT_ID']);
    //     }

    //     if (this.roleId == 6) {
    //       this.search(true);
    //     }
    //   }
    // });
  }

  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);
  }

  exportexcel(): void {
    let element = document.getElementById('summer');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  changeDate(value) {
    this.value1 = this.datePipe.transform(value[0], "yyyy-MM-dd")
    this.value2 = this.datePipe.transform(value[1], "yyyy-MM-dd");
  }

  search(reset: boolean = false, exportToExcel: boolean = false, exportToPDF: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";

    } catch (error) {
      sort = "";
    }

    var likeQuery = "";
    if (this.searchText != "") {
      likeQuery = " AND (";

      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });

      likeQuery = likeQuery.substring(0, likeQuery.length - 2) + ')';
    }

    var deptFilter = "";
    if (this.TICKET_GROUP.length > 0)
      deptFilter = " AND TICKET_GROUP_ID IN (" + this.TICKET_GROUP + ")";

  var deptCondition = "";
if (this.roleId == 4) {

    if (Array.isArray(this.supportAgentWiseDeptArray) && this.supportAgentWiseDeptArray.length > 0) {
    deptCondition = this.supportAgentWiseDeptArray.join(',');
  
  }
}

else if (this.roleId == 6) {
   if (Array.isArray(this.DEPARTMENT_ID) && this.DEPARTMENT_ID.length > 0) {
    deptCondition = this.DEPARTMENT_ID.join(',');
  }
}

// else {
//     if (Array.isArray(this.DEPARTMENT_ID) && this.DEPARTMENT_ID.length > 0) {
//     deptCondition = this.DEPARTMENT_ID.join(',');
//   }
// }

    var dateFilter = "";
    if ((this.date1 != undefined) && (this.date2 != undefined)) {
      dateFilter = " AND (DATE BETWEEN '" + this.datePipe.transform(this.date1, 'yyyy-MM-dd 00:00:00') + "' AND '" + this.datePipe.transform(this.date2, 'yyyy-MM-dd 23:59:59') + "')";
    }
var employeeFilter = "";
    if ((this.roleId == 4) ){
      employeeFilter = " AND TAKEN_BY_USER_ID=" + this.userId;

    } 
   let supportUserFilter = "";
console.log(this.SUPPORT_USERS)
if (this.roleId == 6) {
  // ✅ Only role 6 → TAKEN_BY_USER_ID
  if (this.SUPPORT_USERS && this.SUPPORT_USERS.length > 0) {
    supportUserFilter =
      ' AND TAKEN_BY_USER_ID IN (' + this.SUPPORT_USERS.join(',') + ')';
  } 
  // else {
  //   supportUserFilter = ' AND 1=0';
  // }

} else {
  // ✅ All other roles → CREATOR_EMPLOYEE_ID
  if (this.SUPPORT_USERS && this.SUPPORT_USERS.length > 0) {
    supportUserFilter =
      " AND CREATOR_EMPLOYEE_ID IN (" + this.SUPPORT_USERS.join(',') + ")";
  }
}
    if (exportToExcel) {
      this.exportLoading = true;

      this.api.getTicketGroupWiseSummaryReport(0, 0, this.sortKey, sort, likeQuery + deptFilter  + supportUserFilter  + dateFilter +employeeFilter,deptCondition).subscribe(data => {
        if (data['code'] == 200) {
          this.exportLoading = false;
          this.dataListForExport = data['data'];
          this.convertInExcel();
        }

      }, err => {
        if (err['ok'] == false)
          this.message.error("Server Not Found", "");
      });

    } else if (exportToPDF) {
      this.exportInPDFLoading = true;

      this.api.getTicketGroupWiseSummaryReport(0, 0, this.sortKey, sort, likeQuery + deptFilter  + supportUserFilter  + dateFilter +employeeFilter,deptCondition).subscribe(data => {
        if (data['code'] == 200) {
          this.exportInPDFLoading = false;
          this.dataListForExport = data['data'];
          this.isPDFModalVisible = true;
        }

      }, err => {
        if (err['ok'] == false)
          this.message.error("Server Not Found", "");
      });

    } else {
      this.loadingRecords = true;

      this.api.getTicketGroupWiseSummaryReport(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery + deptFilter   + dateFilter + employeeFilter + supportUserFilter ,deptCondition).subscribe(data => {
        if (data['code'] == 200) {
          this.loadingRecords = false;
          this.totalRecords = data['count'];
          this.dataList = data['data'];
        }

      }, err => {
        if (err['ok'] == false)
          this.message.error("Server Not Found", "");
      });
    }
  }

  showFilter() {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";

    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.TICKET_GROUP = [];
    this.date = [];
    this.filterQuery = "";
    this.selectedDate = null;
    this.value1 = '';
    this.value2 = '';
    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";
    this.setDateForDeptWiseFilter();
    this.search(true);
  }

  applyFilter() {
    if (((this.date1 != null) && (this.date2 != null)) || (this.TICKET_GROUP.length > 0))
      this.isFilterApplied = "primary";

    else
      this.isFilterApplied = "default";

    this.search(true);
    this.filterClass = "filter-invisible";
  }

  exportLoading: boolean = false;

  importInExcel() {
    this.search(true, true);
  }

  convertInExcel() {
    var arry1 = [];
    var obj1: any = new Object();

    for (var i = 0; i < this.dataListForExport.length; i++) {
      obj1['Ticket Group'] = this.dataListForExport[i]['TICKET_GROUP_VALUE'];
      obj1['Total Ticket(s)'] = this.dataListForExport[i]['TOTAL'];
      obj1['Pending'] = this.dataListForExport[i]['CREATED'];
      obj1['Assigned'] = this.dataListForExport[i]['ASSIGNED'];
      obj1['Answered'] = this.dataListForExport[i]['ANSWERED'];
      obj1['Re-Opened'] = this.dataListForExport[i]['RE_OPEN'];
      obj1['Closed'] = this.dataListForExport[i]['CLOSED'];
      obj1['Banned'] = this.dataListForExport[i]['BANNED'];
      obj1['On Hold'] = this.dataListForExport[i]['ON_HOLD'];

      arry1.push(Object.assign({}, obj1));

      if (i == this.dataListForExport.length - 1) {
        this._exportService.exportExcel(arry1, 'Ticket Group Wise Summary ' + this.datePipe.transform(new Date(), 'dd-MMM-yy, hh mm ss a'));
      }
    }
  }

  isPDFModalVisible: boolean = false;
  PDFModalTitle: string = "Export in PDF";
  exportInPDFLoading: boolean = false;
  ticketGroupsToPrint: string = "";

  importInPDF(ticketGroupID) {
    this.ticketGroupsToPrint = "";
    this.search(false, false, true);
    let tempTicketGroups = "";

    for (var i = 0; i < ticketGroupID.length; i++) {
      let ticketGroups = this.ticketGroups.filter(obj1 => {
        return obj1.ID == ticketGroupID[i];
      });

      tempTicketGroups = tempTicketGroups + ticketGroups[0]["VALUE"] + ", ";
    }

    this.ticketGroupsToPrint = tempTicketGroups.substring(0, tempTicketGroups.length - 2);
  }

  handlePDFModalCancel() {
    this.isPDFModalVisible = false;
  }

  getCurrentDateTime() {
    return new Date();
  }

  getUserName() {
    return this.api.userName;
  }

  getTicketGroups() {
    if (this.ticketGroupsToPrint == "")
      return "All";

    else
      return this.ticketGroupsToPrint;
  }
}
